import PageLayout from './PageLayout';
import { RSVPSection } from '@/components/wedding';

const RSVPPage = () => (
  <PageLayout testId="rsvp-page">
    <RSVPSection />
  </PageLayout>
);

export default RSVPPage;
